import actions from './actions';
import mutations from './mutations';
import { State } from './types';

const state: State = {
  broadcasts: [],
  agendaItems: [],
  agendaTracks: [],
  isBroadcastLoading: false,
  isAgendaItemsLoading: false,
  isAgendaTracksLoading: false,
  errorFetchingAgendaItems: null,
  errorFetchingBroadcasts: null,
  selectedTrack: null
};

export default {
  state,
  mutations,
  actions,
  namespaced: true
};
